export const WIDGET_CATEGORY_DASHBOARD = 'Dashboard';
export const WIDGET_CATEGORY_MONITORING = 'Monitoring';
export const WIDGET_CATEGORY_MANUAL_SEARCH = 'Manual search';
export const WIDGET_ASSET_MANAGEMENT = 'Asset Management';
